import React from "react";
import Select from 'react-select';
import withStyles from "material-ui/styles/withStyles";
import _ from "lodash";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import {getMyPins, checkPin} from "../../graph";
import {client} from "client";


class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.pid;
    this.currentPinValue=null;

    this.state = {
      pinList: [],
      selectValue: "",
      pinState: "",
      validate: false
    };
  }

  componentDidMount() {
    this.pid = this.props.props.data.pid;
    this.getUserPins(this.pid);
  }

  getUserPins(pid) {
      // testing get data from scripted table
      // if (this.props.props.data.collectionType === 2) {
      //     pins(pid, 'yingying', false)
      //         .then((data) => {
      //             const userPins = data.data;
      //
      //             let userPinList = [];
      //             for (let i in userPins) {
      //                 userPinList.push({
      //                     value: userPins[i].pin + '',
      //                     label: userPins[i].pin + " - " + userPins[i].count
      //                 });
      //             }
      //             this.setState({pinList: userPinList});
      //         });
      // }

      client.query({
          query: getMyPins,
          variables: ({projectId: pid}),
          fetchPolicy: "network-only"
      })
          .then((data) => {
              const userPins = data.data.getCurrentUserPins;

              let userPinList = [];
              for (let i in userPins) {
                  const pin = userPins[i].pin;
                  const conv = userPins[i].conversational.edges[0].node;
                  let label = pin;
                  let value = pin;

                  const currentRecordingLength = parseInt(conv.currentRecordingLength);
                  const maxRecordingLength = parseInt(conv.maxRecordingLength);

                  if (currentRecordingLength >= (maxRecordingLength - 70)) {
                      label = `${pin} - Completed`;
                      value = null;
                  } else if (currentRecordingLength > 0){
                      label = `${pin} - ${currentRecordingLength}s`;
                  }

                  userPinList.push({
                      label: label,
                      value: value
                  });
              };

              this.setState({pinList: userPinList});
          });
  }

  onSelectValueChange(value) {
    if (!value || value === null)
      return;

    this.setState({selectValue: value});

    if (this.currentPinValue !== value) {
        this.currentPinValue = parseInt(value);
        if (!_.isEmpty(value)){
          this.autoCheckPin(value);
        }
    }
  }

  autoCheckPin(pin) {
    client.mutate({
      mutation: checkPin,
      variables: ({
        pin: this.currentPinValue,
        uid: localStorage.getItem("APN_USERID"),
        pid: this.pid
      }),
        fetchPolicy: "no-cache"
    }).then((data) => {
      let successData = data.data;
      this.props.props.collectDataCallback("autoFill", successData);
      this.props.props.collectDataCallback("step2FirstRender", null);
      this.props.props.collectDataCallback("step3FirstRender", null);

      this.setState({pinState: "success"});
    }).catch((data) => {
      let errorData = data.graphQLErrors.map(x => x.message);

      if (errorData) {
        const errorMessage = JSON.parse(errorData[0]);
        let stateObj = {
            pinAlertTitle: errorMessage.message,
            showAlert: true,
        };

        if (errorMessage.pin_error_type === 1) {
            stateObj['pinAlertMessage'] = `${errorMessage.remaining_time} time remaining`;
        }

        this.props.props.showAlertCallback(stateObj);
        this.setState({selectValue: null});
      }

      this.setState({pinState: "failed"});
    });
  }

  isValidated() {
    if (this.state.pinState === "success") {
      this.props.props.collectDataCallback('pin', this.currentPinValue);

      return true;
    } else {
      if (this.state.pinState !== "success") {
        this.setState({ pinState: "error" });
      }
    }

    return false;
  }

  render() {
    const { pinList, selectValue } = this.state;

    return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12} md={12} lg={12}>
          <h4>
            Provide the following information to proceed
          </h4>
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={12} lg={12}>
          <Select
            success={this.state.pinState === "success"}
            error={this.state.pinState === "error"}
            id="state-select"
            ref={(ref) => { this.select = ref; }}
            autoFocus
            options={pinList}
            simpleValue
            clearable={false}
            name="selected-state"
            value={selectValue}
            placeholder="Select pins..."
            onChange={this.onSelectValueChange.bind(this)}
          />
        </ItemGrid>
      </GridContainer>
    );
  }
}

export default withStyles(sweetAlertStyle)(Step1);


// WEBPACK FOOTER //
// ./src/views/callform/components/WizardSteps/Step1.jsx